import React from "react";
import { Link } from "react-router-dom";

const TrustedDirectories = () => {
  const [trustedDirectories, setTrustedDirectories] = React.useState([]);

  React.useEffect(() => {
    fetch("https://www.api.webdirectories.info/api/listing/get-all")
      .then((res) => res.json())
      .then((data) => {
        data.map((item) => {
          if (item.listingType === "Trusted" && item.status === "Approved") {
            setTrustedDirectories((prev) => [...prev, item]);
          }
        });
      });
  }, []);
  const formateDate = (date) => {
    const newDate = new Date(date);
    const form = newDate.toLocaleDateString('en-US');
    const formate = form.split("/");
    if (formate[0].length === 1) {
      formate[0] = "0" + formate[0];
    }
    if (formate[1].length === 1) {
      formate[1] = "0" + formate[1];
    }
    const formateDate = formate[0] + "-" + formate[1] + "-" + formate[2];
    return `${formateDate}`;
  };
  return (
    <div style={{ background: "#f6f6f6" }}>
      <section id="hero" className="d-flex align-items-center">
        <div
          className="container hero-banner text-center"
          data-aos="zoom-out"
          data-aos-delay="100"
        >
          <h3 className="text-white font-weight-bold text-center">
            Trusted Directory List
          </h3>
          <div className="mt-3">
            <h4 className="text-center text-secondary">Home</h4>
            <span style={{ color: "#f38e35" }}>
              <i class="bi bi-caret-right mx-1"></i>
            </span>
            <a className="text-white">Trusted Directory List</a>
          </div>
        </div>
      </section>
      <div className="container py-3">
        <div className="py-3 px-3 " style={{ background: "#fff" }}>
          <strong className="mr-2 text-center" style={{ paddingRight: "5px" }}>
            Home
            <span style={{ color: "#f38e35" }}>
              <i class="bi bi-caret-right"></i>
            </span>
          </strong>{" "}
          Trusted Directory List
        </div>
      </div>
      <div className="container mt-2">
        <div className="mb-5 d-flex ">
          <div className="my-3 py-4" style={{ background: "#fff" }}>
            <div className="d-flex align-items-start  flex-column px-3">
              <table className="table text-center table-bordered">    
                <thead>
                  <tr>
                    <th>WD Rank</th>
                    <th>Directory Name</th>
                    <th>Directory URL</th>
                    <th>Domain Authority</th>
                    <th>Monthly Visits</th>

                    <th>Date Added To List</th>

                    <th>Report Site</th>
                  </tr>
                </thead>
                <tbody>
                  {trustedDirectories.length > 0 ? (
                    trustedDirectories.map((item, index) => (
                      <tr>
                        <td className="text-center">{index + 1}</td>
                        <td>{item.businessName}</td>
                        <td>
                          <a className="directory-url" href={item.websiteURL} target="_blank">
                            {item?.websiteURL}
                          </a>
                        </td>
                        <td>{item?.pageRank}</td>
                        <td>{item?.alexaRank}</td>

                        <td className="no-wrap">
                          {formateDate(item.createdAt)}
                        </td>

                        <td className="text-center">
                          <Link to={`/detailed-view/${item._id}`}>
                            <i class="bi bi-play-circle-fill"></i>
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <div className="d-flex align-items-start  flex-column px-3">
                      <h6>No Trusted Directory Found</h6>
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedDirectories;
